module.exports = __webpack_public_path__ + "static/media/vnit-logo.27fc3a93.png";